import { createAction, props } from '@ngrx/store';
import { UserAddressSearchSuccessArgs } from '@lentau/address/shared/interfaces';

export const userMercuryAddressSearch = createAction('[userMercuryAddressSearch] Get User Address Mercury List');
export const userMercuryAddressSearchFail = createAction(
  '[userMercuryAddressSearch] Get User Address Mercury List Fail'
);
export const userMercuryAddressSearchSuccess = createAction(
  '[userMercuryAddressSearch] Get User Address Mercury List Success',
  props<UserAddressSearchSuccessArgs>()
);
